import { ndp2iiifUrl, ndp2iiifLogin, ndp2iiifPassword, backendUrl } from './config'

function RequestOptions () {
    let headers = new Headers();
    headers.set('Accept', 'application/json')
    headers.set('Content-Type', 'application/json')
    return {
        headers: headers
    }
}

function GetRequestOptions (with_auth) {
    let requestOptions = RequestOptions()
    if(with_auth) {
        requestOptions.headers.set('Authorization', 'Basic ' + btoa(ndp2iiifLogin + ":" + ndp2iiifPassword))
    }
    requestOptions.method = 'GET'
    return requestOptions
}

function PostRequestOptions (body) {
    let requestOptions = RequestOptions()
    requestOptions.method = 'POST'
    if (body) {
        requestOptions.body = JSON.stringify(body)
    }
    return requestOptions
}

const GetSlideMetadata = function (slide) {
    return new Promise((resolve, reject) => {
        fetch(ndp2iiifUrl + '/ndp2iiif/metadata/' + slide, GetRequestOptions(false))
        .then(async response => {
            if (response.status === 200) {  
                resolve(response.text())
            }
            else{
                reject(response.statusText)
            }
        })
        .catch(e => {
            reject(e)
        })
    })
}

const GetIIIFjson = function (slide, stack) {
    return new Promise((resolve, reject) => {
        fetch(ndp2iiifUrl + '/ndp2iiif/json/' + slide + '/' + stack, GetRequestOptions(false))
        .then(async response => {
            if (response.status === 200) {  
                resolve(response.json())
            }
            else{
                reject(response.statusText)
            }
        })
        .catch(e => {
            reject(e)
        })
    })
}

const GetIIIFMacro = function (slide) {
    return new Promise((resolve, reject) => {
        fetch(ndp2iiifUrl + '/ndp2iiif/macro/' + slide, GetRequestOptions(false))
        .then(async response => {
            if (response.status === 200) {  
                resolve(response.arrayBuffer())
            }
            else{
                reject(response.statusText)
            }
        })
        .catch(e => {
            reject(e)
        })
    })
}

const GetSlides = function () {
    return new Promise((resolve, reject) => {
        fetch(backendUrl + '/slides', GetRequestOptions(false))
        .then(async response => {
            if (response.status === 200) {  
                resolve(response.json())
            }
            else{
                reject(await response.text())
            }
        })
        .catch(e => {
            reject(e)
        })
    })
}

const GetAnalysis = function (analysis_file_name) {
    return new Promise((resolve, reject) => {
        fetch(backendUrl + '/analysis?' + new URLSearchParams({analysis_file_name: analysis_file_name}), GetRequestOptions(false))
        .then(async response => {
            if (response.status === 200) {  
                resolve(response.json())
            }
            else{
                reject(await response.text())
            }
        })
        .catch(e => {
            reject(e)
        })
    })
}

const PostRegister = function (name, firstname, email) {
    return new Promise((resolve, reject) => {
        fetch(backendUrl + '/register', PostRequestOptions(
            {
                'user': {
                    'name' : name,
                    'firstname': firstname,
                    'email' : email
                }
            }
        ))
        .then(async response => {
            if (response.status === 200) {  
                resolve(response.json())
            }
            else{
                reject(await response.text())
            }
        })
        .catch(e => {
            reject(e)
        })
    })
}

const PostDiagnosis = function (value, slide_name, user_id) {
    let diagnosis = {
        'value' : value,
        'slide_name': slide_name
    }
    if(user_id) {
        diagnosis['user_id'] = user_id
    }
    console.log(diagnosis)
    return new Promise((resolve, reject) => {
        fetch(backendUrl + '/diagnosis', PostRequestOptions(
            {
                'diagnosis': diagnosis
            }
        ))
        .then(async response => {
            if (response.status === 200) {  
                resolve(response.json())
            }
            else{
                reject(await response.text())
            }
        })
        .catch(e => {
            reject(e)
        })
    })
}


export { GetSlideMetadata, GetIIIFjson, GetIIIFMacro, PostRegister, PostDiagnosis,
    GetSlides, GetAnalysis }
